import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
// import { createAction } from "redux-actions";
import { queryParams } from "../../../utils/queryParams.js";
import moment from "moment";
import { api } from "./constants.js";
import { API_DATE_FORMAT } from "../../../app_constants.js";

export const SET_LOADING = "saga/SET_LOADING/";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER/";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS/";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE/";

export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS/";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE/";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE/";
export const UPDATE_DATES = "saga/UPDATE_DATES/";
export const UPDATE_DATA_BY_STAFF = "saga/UPDATE_DATA_BY_STAFF/";

export const FETCH_FILTERS = "saga/FETCH_FILTERS/";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS/";
export const FETCH_FILTERS_FAILURE = "saga/FETCH_FILTERS_FAILURE/";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY/";

export const FETCH_DATA = "saga/FETCH_DATA/";
export const FETCH_DATA_SUCCESS = "saga/FETCH_DATA_SUCCESS/";
export const FETCH_DATA_FAILURE = "saga/FETCH_DATA_FAILURE/";

export const SET_STAFF_FILTERS_LOADING = "saga/SET_STAFF_FILTERS_LOADING/";
export const SET_CUSTOM_DATE_RANGE_LOADING = "saga/SET_CUSTOM_DATE_RANGE_LOADING/";

export const UPDATE_STAFF_FILTERS = "saga/UPDATE_STAFF_FILTERS/";
export const SET_DATES = "saga/SET_DATES/";

export default function* watchActiveMembers(moduleName) {
  yield takeLatest(FETCH_CURRENT_USER + moduleName, getCurrentUserData);
  yield takeLatest(FETCH_DATA + moduleName, fetchData);
  yield takeLatest(UPDATE_DATA_BY_STAFF + moduleName, updateDataByStaff);
  yield takeLatest(UPDATE_CUSTOM_RANGE + moduleName, updateCustomRange);
  yield takeLatest(UPDATE_DATES + moduleName, updateDates);
}

let date;

export function* getCurrentUserData({ payload }) {
  const chartType = payload.chartType || "";
  yield put({ type: FETCH_CURRENT_USER_SUCCESS + chartType, payload: payload });
  yield put({ type: SET_LOADING + chartType, payload: true });
  yield put({ type: SET_FILTERS_DIRTY + chartType, payload: false });
  date = payload.date || (yield select((state) => state[chartType].currentUser.calendarEndDate));

  yield put({
    type: SET_DATES + chartType,
    payload: {
      startDate: moment(date).startOf("month").format(API_DATE_FORMAT),
      endDate: date
    }
  });

  try {
    // first fetching staff TODO: note that in future it can be filters object with staff and other filters
    yield fetchFilters(chartType);
    // by default all staff is selected thus, fetch data which contains table and chart
    yield fetchData({ chartType });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchFilters(chartType = "") {
  let { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  let {
    selectedStaffFilters,
    selectedRequestDates: { startDate, endDate }
  } = yield select((state) => {
    return state[chartType];
  });

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + `pages/instructor_performance/${api[chartType]}/filters`,
      {
        organization_id: organization_id.toString(),
        short_url,
        start_date: startDate,
        end_date: endDate,
        staff_id: getIds(selectedStaffFilters)
      }
    );

    yield put({ type: FETCH_FILTERS_SUCCESS + chartType, payload: response.data });
    return response.data;
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FILTERS_FAILURE + chartType, error });
  }
}

export function* fetchData(payload) {
  yield put({ type: SET_LOADING + payload.chartType, payload: true });
  let { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  let {
    selectedStaffFilters,
    selectedRequestDates: { startDate, endDate },
    currentUser: { visitStatus }
  } = yield select((state) => state[payload.chartType]);

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + `pages/instructor_performance/${api[payload.chartType]}/values`,
      {
        organization_id: organization_id.toString(),
        short_url,
        staff_id: getIds(selectedStaffFilters),
        start_date: startDate,
        end_date: endDate,
        visit_status: visitStatus
      }
    );
    yield put({ type: FETCH_DATA_SUCCESS + payload.chartType, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_FAILURE + payload.chartType, error });
  }
}

export function getIds(data) {
  let ids = "";
  data.map((item) => {
    ids = ids + item.id + ",";
  });
  return ids;
}

export function* updateCustomRange({ payload }) {
  yield put({ type: SET_STAFF_FILTERS_LOADING + payload.chartType, payload: true });
  try {
    yield fetchFilters(payload.chartType);
    yield put({ type: SET_STAFF_FILTERS_LOADING + payload.chartType, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateDataByStaff({ payload }) {
  yield put({ type: UPDATE_STAFF_FILTERS + payload.chartType, payload: payload.data });
  try {
    yield fetchFilters(payload.chartType);
  } catch (error) {
    console.error(error);
  }
}

export function* updateDates({ payload }) {
  yield put({ type: SET_STAFF_FILTERS_LOADING + payload.chartType, payload: true });
  yield put({ type: SET_CUSTOM_DATE_RANGE_LOADING + payload.chartType, payload: true });
  try {
    yield fetchFilters(payload.chartType);
    yield put({ type: SET_STAFF_FILTERS_LOADING + payload.chartType, payload: false });
    yield put({ type: SET_CUSTOM_DATE_RANGE_LOADING + payload.chartType, payload: false });
  } catch (error) {
    console.error(error);
  }
}
